<template>
  <div class="pay-succ">
    <img src="@/assets/images_member/icon-ding2 (8).png" class="img" alt="">
    <div class="pay-txt1">支付成功</div>>
    <div class="pay-txt2">
      <div class="label">充值成功： </div>
      <div class="val">{{ price }}</div>
    </div>
    <div class="btn-txt" @click="handleJump">返回</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      price: ''
    }
  },
  created () {
    this.price = this.$route.query.price
  },
  methods: {
    handleJump () {
      this.$router.push({
        path: '/'
      })
    }
  },
}
</script>

<style lang="less" scoped>
.pay-succ {
  background-color: #1E2020;
  padding: 30px 14px;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;

  .img {
    width: 146px;
    display: block;
    margin-left: 50%;
    transform: translateX(-46%);
    margin-top: 20px;
  }

  .pay-txt1 {
    font-size: 20px;
    color: #F0E1C0;
    font-weight: bold;
    line-height: 20px;
    margin-top: 24px;
    text-align: center;
  }

  .pay-txt2 {
    text-align: center;
    color: #fff;
    font-size: 12px;
    display: flex;
    line-height: 24px;
    justify-content: center;
  }

  .btn-txt {
    width: 50%;
    height: 48px;
    text-align: center;
    line-height: 48px;
    height: 48px;
    display: block;
    border-radius: 100px;
    font-size: 18px;
    font-weight: 600;
    background-color: #F0E1C0;
    color: #504632;
    margin-left: 25%;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/rechargeSuccess.vue